import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import "../assets/css/Video.css";
import { Link } from "gatsby";
import posterImage from "../assets/Images/Hero/bbis-commercial-1-min.jpg"
import React, { lazy, Suspense } from "react";


const VideoContent = lazy(() => import("./VideoContent"));

export const Video = () => {
  const data = useStaticQuery(graphql`
    query {
      epicDev: file(relativePath: { eq: "ed.png" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 70, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <div class="video-background-holder">
      <div class="video-background-overlay"></div>
      <video
        playsinline="playsinline"
        autoplay="autoplay"
        muted="muted"
        loop="loop"
      >

      </video>

            <video
        playsInline
        autoPlay
        muted
        loop
        poster={posterImage}
      >

                <source
          src="../assets/Videos/bbisvideo.mp4"
          type="video/mp4"
        />
      </video>
      <div class="video-background-content container h-100">
        <div class="d-flex h-100 text-center align-items-center">
          <div class="w-100 text-white">
            <h1 class="display-4"></h1>
            <p class="lead mb-1"></p>
            <p class="lead">
              {/* <Link class="btn btn-light" to="/projects/">Example Projects</Link> */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
